import { useSelector } from 'react-redux'
import { useTranslation } from 'next-i18next'

import React from 'react'
import styled from '@emotion/styled'
import { RootState } from '../../../../redux/store'
import { UiIcon } from '../../../ui/atoms/Icon'
import { capitalizePhrase } from '../../../../utils/capitalize'
import { Tooltip } from '../../../ui/atoms/Tooltip'
import { DEFAULT_THEME_COLORS } from '../../../../css/theme'

const Header = styled.div`
  background-color: #f0fce9;
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  strong {
    white-space: nowrap;
  }
`

export default function DedicationPreConversionPreview() {
  const urlParams = useSelector((state: RootState) => state.urlParams)
  const dedication = urlParams.dedication
  const { t } = useTranslation()

  return (
    <>
      {dedication && (
        <Header>
          <UiIcon
            aria-hidden="true"
            name="donation"
            color={DEFAULT_THEME_COLORS['--theme-color--status-error']}
            w={20}
            h={20}
          />
          {t('dedicationPreConversionPreview.dedicatedTo', 'Dedicated to')}{' '}
          <strong>{capitalizePhrase(dedication)}</strong>
          <Tooltip
            text={t(`You'll be able to add a note and complete your dedication later.`)}
            placement="top"
          >
            <UiIcon name="info" color="#1B1918" w={18} style={{ marginTop: '2px' }} />
          </Tooltip>
        </Header>
      )}
    </>
  )
}
